// お知らせ・元に戻す・やり直す（2026-10-21 に app.js から分けた）
import { S } from './state.js';
import { C } from './core/model.js';
import { txt } from './text.js';
import { $, keyOf } from './util.js';
import { saveObject } from './core/savedata.js';
import { selectCategory } from './categories.js';
import { pop } from './parts.js';
import { scheduleAutosave } from './storage.js';
import type { HistEntry, Snapshot } from './state.js';
import { restoreState } from './core/ops.js';
import { syncHistory } from './side.js';
export function snapshot(): Snapshot { return { state: JSON.parse(JSON.stringify(C.state)), name: C.name.slice() as [string, string] }; }

// ---- 元に戻す・やり直す ----
// 変えるたびに（render・place・名前から呼ばれる scheduleAutosave のついでに）、少し止まったところで前の形を1つ残す。
// ドラッグ・つまみ・自由な色・名前を打つなど続けて変わるものは、止まったところまでで1回分。パーツを選ぶ・色を押すなどのはっきりした操作は、
// 始める前にそれまでの分を区切る（histCut）ので、続けて押しても1回ずつ戻せる。HIST_MAX 回まで。ページを開き直すと消える（保存データには入れない）。
// 戻したり進めたりしたら、変わったカテゴリを選んで見せる。ランダムなどのお知らせの「元に戻す」も、これの1回分
export const HIST_MAX = 50, HIST_WAIT = 400;
export function histNow(): HistEntry { return { snap: snapshot(), key: JSON.stringify(saveObject()) }; }
export function histReset() {
  clearTimeout(S.hist.timer);
  S.hist = { base: histNow(), past: [], future: [], timer: 0, applying: false };
  updateHistButtons();
}
export function histCommit() {
  clearTimeout(S.hist.timer);
  S.hist.timer = 0;
  if (!S.hist.base) return;
  const now = histNow();
  if (now.key !== S.hist.base.key) {
    S.hist.past.push(S.hist.base);
    if (S.hist.past.length > HIST_MAX) S.hist.past.shift();
    S.hist.future = [];
    S.hist.base = now;
  }
  updateHistButtons();
}
export function histTouch() {
  if (S.hist.applying || !S.hist.base) return;
  clearTimeout(S.hist.timer);
  // 描き直しただけ（柄を読んだあとなど）で中身が変わっていなければ待たない
  S.hist.timer = JSON.stringify(saveObject()) === S.hist.base.key ? 0 : setTimeout(histCommit, HIST_WAIT);
  updateHistButtons();
}
export function histCut() { if (S.hist.timer) histCommit(); }
// dir: -1 戻す・1 進める。できたら true
export function histStep(dir: number) {
  histCommit();
  const from = dir < 0 ? S.hist.past : S.hist.future, to = dir < 0 ? S.hist.future : S.hist.past;
  if (!from.length) return false;
  const target = from.pop()!;
  to.push(S.hist.base!);
  const before = C.state;
  S.hist.applying = true;
  restoreState(JSON.parse(JSON.stringify(target.snap.state)), target.snap.name.slice() as [string, string]); // 名前は applied の知らせで描き直す
  S.hist.base = target;
  // 変わったカテゴリを選ぶ（名前だけのときは今のまま）
  let changed: string | null = null;
  C.cats.forEach((c) => {
    const k = keyOf(c);
    if (!changed && k !== 'chara' && JSON.stringify(before[k] || null) !== JSON.stringify(C.state[k] || null)) changed = k;
  });
  selectCategory(changed || S.selKey);
  scheduleAutosave(); // 作りかけにも残す（履歴には足さない）
  S.hist.applying = false;
  updateHistButtons();
  return true;
}
export function updateHistButtons() {
  const u = $<HTMLButtonElement>('btnUndo'), r = $<HTMLButtonElement>('btnRedo');
  if (!u) return;
  u.disabled = !(S.hist.past.length || S.hist.timer);
  r.disabled = !S.hist.future.length;
  syncHistory(); // 全身のメーカーのスマホの右の列
}
export function bindHistory() {
  $('btnUndo').addEventListener('click', () => { histStep(-1); });
  $('btnRedo').addEventListener('click', () => { histStep(1); });
  // PC: Ctrl（Mac は ⌘）+ Z で戻す、Ctrl + Shift + Z・Ctrl + Y で進める（文字を打つ欄の中では、その欄の元に戻すのまま）
  document.addEventListener('keydown', (e) => {
    if (!(e.ctrlKey || e.metaKey) || e.altKey) return;
    const t = e.target as HTMLElement | null, tag = t && t.tagName ? t.tagName.toLowerCase() : '';
    if (tag === 'input' || tag === 'textarea' || (t && t.isContentEditable)) return;
    if (!$('finish').hidden) return;
    const k = e.key.toLowerCase();
    if (k === 'z' && !e.shiftKey) { e.preventDefault(); histStep(-1); }
    else if ((k === 'z' && e.shiftKey) || k === 'y') { e.preventDefault(); histStep(1); }
  });
  updateHistButtons();
}
// ms: 出しておく時間（省略すると「元に戻す」付きは 6 秒、それ以外は 2 秒）
export function toast(text: string, snap?: Snapshot | null, ms?: number) {
  $('toastText').textContent = text;
  S.undoSnap = snap || null;
  $('toastUndo').hidden = !S.undoSnap;
  $('toast').classList.add('show');
  clearTimeout(S.toastTimer);
  S.toastTimer = setTimeout(hideToast, ms || (S.undoSnap ? 6000 : 2000));
}
export function hideToast() { $('toast').classList.remove('show'); S.undoSnap = null; }
export function undo() {
  if (!S.undoSnap) return;
  if (histStep(-1)) { pop(); toast(txt('undone')); }
}
